jQuery(function ($) {
    $(document).ready(function(){
        // Gallery SLider
        $('.gallery-slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrow: true
        });
    });
});